


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCvuiFjnuj460AM2bWxPVJZH2Df_aWYWiY",
  authDomain: "crm-trial-6071e.firebaseapp.com",
  projectId: "crm-trial-6071e",
  storageBucket: "crm-trial-6071e.firebasestorage.app",
  messagingSenderId: "819084037776",
  appId: "1:819084037776:web:960083a5f0fb3d36245215"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export